export default __webpack_public_path__ + "static/onewindow-9c6639be21384d66aebcc6d27d42a0b1.png";